<template>
    <main class="pd-main">
        <div class="main-content">
            <header class="header no-border">
                <div class="header-bar">
                <h4 class="text-uppercase">Dashboard</h4>
                </div>
            </header>
            <circle-spin class="m-0" v-if="loading"></circle-spin>
            <div class="row" v-else>
                <div class="col-xl-3 col-md-4">
                    <a href="#">
                    <div class="card card-body">
                    <h6 class="text-uppercase"> Listener Accounts</h6>
                    <div class="flexbox mt-2">
                        <span class="ion-ios-people text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{meta_data.listener}}</h6>
                    </div>
                    </div> 
                    </a>
                    
                </div>
                
                <div class="col-xl-3 col-md-4">
                    <div class="card card-body">
                    <h6 class="text-uppercase"> Member Accounts</h6>
                    <div class="flexbox mt-2">
                        <span class="ion-ios-people-outline text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{meta_data.helpseeker}}</h6>
                    </div>
                    </div>
                </div>
                <div class="col-xl-3 col-md-4" v-if="!is_Admin">
                    <div class="card card-body">
                    <h6 class="text-uppercase">Admin MEMBERS </h6>
                    <div class="flexbox mt-2">
                        <span class="ion-android-people text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{meta_data.admin}}</h6>
                    </div>
                    </div>
                </div>
                <div class="col-xl-3 col-md-4">
                    <div class="card card-body">
                    <h6 class="text-uppercase">VOLUNTEERS </h6>
                    <div class="flexbox mt-2">
                        <span class="ion-android-contacts text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{meta_data.volunteer}}</h6>
                    </div>
                    </div>
                </div>
                <div class="col-xl-3 col-md-4">
                    <div class="card card-body">
                    <h6 class="text-uppercase">REGISTERED CAMPUS CLUBS </h6>
                    <div class="flexbox mt-2">
                        <span class="ion-bookmark text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{meta_data.campusclub}}</h6>
                    </div>
                    </div>
                </div>
                <div class="col-xl-3 col-md-4">
                    <div class="card card-body">
                    <h6 class="text-uppercase">ALL EVENTS </h6>
                    <div class="flexbox mt-2">
                        <span class="ion-calendar text-primary font-s"></span>
                        <h6 class="mb-0 font-s">{{meta_data.event}}</h6>
                    </div>
                    </div>
                </div>
            </div>
            
        </div>
    </main>
</template>


<script>
import axios from 'axios'
import allMixins from '../../mixins.js'

export default {
    mixins: [allMixins],
    data() {
        return {
            loading: false,
            meta_data: {},
            is_Admin: false
        }
    },
    mounted() {
        this.loading = true
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
        if (details.userRoles.includes("admin_member")) {
            this.is_Admin = true
        }
        // Load all the counts
        axios.get('/admin/count')
        .then(res => {
            this.loading = false
            this.meta_data = res.data.data
        })
        .catch(err => {
            this.$notify({
                group: 'response',
                type: 'error',
                title: 'An Error Occured. Kindly refresh.',
                duration: 5000
            });
        })
    }
}
</script>
